import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { consumeCallback, redirectToLogin } from '../auth/authClient.js';
import { clearRetryFlag, markRetried, shouldAutoRetry } from '../auth/callbackRetryGuard.js';
import { t } from '../i18n/es.js';

export function CallbackPage(): JSX.Element {
  const navigate = useNavigate();
  const [error, setError] = useState<string | null>(null);
  const [retrying, setRetrying] = useState(false);

  useEffect(() => {
    consumeCallback()
      .then((returnTo) => {
        clearRetryFlag();
        navigate(returnTo, { replace: true });
      })
      .catch((err: unknown) => {
        const msg = err instanceof Error ? err.message : 'unknown';
        setError(msg);
        // #144: el flag va en sessionStorage, no en estado de React; si
        // viviera en memoria se perdería en el propio redirect y el ciclo
        // login -> Cognito (SSO) -> callback -> login no terminaría nunca.
        if (shouldAutoRetry(msg)) {
          markRetried();
          setRetrying(true);
          void redirectToLogin('/');
        }
      });
  }, [navigate]);

  if (error && retrying) {
    return <div className="p-6 text-sm text-ink-3">{t.callback.retrying}</div>;
  }
  if (error) {
    return (
      <div className="space-y-3 p-6 text-sm">
        <p className="text-err">
          {t.callback.missingTokens}: <span className="font-mono text-xs">{error}</span>
        </p>
        <button
          type="button"
          onClick={() => {
            setError(null);
            void redirectToLogin('/');
          }}
          className="btn btn-primary"
        >
          {t.callback.retry}
        </button>
      </div>
    );
  }
  return <div className="p-6 text-sm text-ink-3">{t.callback.processing}</div>;
}
